import { render } from "./wjedit.vue?vue&type=template&id=627cac58&scoped=true"
import script from "./wjedit.vue?vue&type=script&lang=js"
export * from "./wjedit.vue?vue&type=script&lang=js"

import "./wjedit.vue?vue&type=style&index=0&id=627cac58&lang=scss&scoped=true"
import "./wjedit.vue?vue&type=style&index=1&id=627cac58&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627cac58"]])

export default __exports__